import {defineStore} from "pinia";
export const reporteStore = defineStore("reporteStore", {
    state: () =>
        ({
            loading: false as boolean,
            pagination: {
                per_page: 0,
                current_page: 1,
                last_page: 0,
            },
            partidaGasto: [],
            showDialog: false as boolean,
            cuentaContable: [],
            resumenIngresosCuentaContable: [],
            cantidadesCalculadas: [],
            subtotales: []
        }),
});